export const PRIVACY_POLICY_URL = '/privacy-policy'
export const MAIN_NAVIGATION_ABOUT_TAB_URL = '/about'
export const VAN_CAMPAIGN_PRIVACY_POLICY_URL = (id: string) => `/van-privacy-policy/${id}`
